import { IApplicationState } from '../../types/redux';
import { getTemplateSpecialPromo } from './templateSpecialPromo/getTemplateSpecialPromo';

export function getPinImage(state: IApplicationState): string | null {
  return getTemplateSpecialPromo(state)?.pinImage.url ?? null;
}
